<template>
    <transition name="modal">
            <div class="modal-mask">
                <div class="modal-wrapper">
                    <div class="modal-container">
                        <div class="modal-header align-items-center no-gutters" v-if="!triggers.success">
                            <div class="col-10">Agregá una nueva asignacion</div>
                            <div class="col-2 text-right">
                                <button type="button" class="btn btn-sm btn-light font-weight-bold" @click.prevent="close()"> x </button>
                            </div>
                        </div>

                        <div class="modal-body m-0" v-if="triggers.success">
                            <h5 class="text-success text-center mt-1">✓ Asignacion creada</h5>
                        </div>

                        <div class="modal-body" v-if="!triggers.success">
                            
<div class="row mt-3">
    <div class="col">
                            <label for="selectEmpleado" class="form-label">Seleccioná un empleado</label>
                            <Select2 class="w-100 input-error" v-model="operacionSeleccionada" :options="listadoPersonalActivo" :settings="{ width:'100%', theme: 'classic' }" @select="guardarSeleccion($event)"/>
                            <span class="text-danger" v-if="errors.dni">· Seleccioná un empleado</span>
    </div>

      <div class="col">
                                    <label for="sector">Seleccioná sector</label>
                                    <select class="custom-select mr-3 resolucionSelect" v-model="ticket.sector">
                                        <option value="-">-</option>
                                        <option value="OPERACION">OPERACION</option>
                                        <option value="PLANTA">PLANTA</option>
                                    </select>
                                </div>

   </div>
                            <div class="row mt-3">
                                <div class="col">
                                    <label for="novedad">¿Cual es la licencia reportada?</label>
                                    <select class="custom-select mb-1 resolucionSelect" v-model="ticket.novedad" @change="errors.novedad = false">
                                        <option :value="null" disabled>Selecciona una licencia</option>
                                        <option v-for="(novedad,i) in novedades" :key="i" :value="novedad">{{novedad}}</option>
                                    </select>
                                    <span class="text-danger" v-if="errors.novedad">· Seleccioná una novedad</span>
                                </div>
                                <div class="col">
                                    <label for="novedad">Seleccioná el estado actual</label>
                                    <select class="custom-select mr-3 resolucionSelect" v-model="ticket.status">
                                        <option value="ABIERTO" selected>ABIERTO</option>
                                        <option value="CERRADO">CERRADO</option>
                                    </select>
                                </div>
                            </div>


<div class="row mt-3">

     <div class="col">
                            <!-- Fecha de inicio de la licencia -->
                            <label class="form-label mt-3">Fecha de inicio de la licencia</label>
                            <input type="date" class="form-control" v-model="ticket.fechaInicioLicencia" @change="errors.fechaInicioLicencia = false">
                            <span class="text-danger" v-if="errors.fechaInicioLicencia">· Seleccioná una fecha</span>
    </div>

     <div class="col">

                             <!-- Fecha de fin de la licencia -->
                            <label class="form-label mt-3">Fecha de fin de la licencia</label>
                            <input type="date" class="form-control" v-model="ticket.fechaFinLicencia" @change="errors.fechaFinLicencia = false">
                            <span class="text-danger" v-if="errors.fechaFinLicencia">· Seleccioná una fecha</span>
    </div>

</div>



<div class="row mt-3">

<div class="col">

                            <!-- Diagnóstico -->
                            <label class="form-label mt-3">Diagnóstico</label>
                             <select class="custom-select" v-model="ticket.diagnostico">
                                <option :value="null" disabled>Selecciona un tipo</option>
                                <option value="Algia">Algia</option>
                                <option value="Traumatismo">Traumatismo</option>
                                <option value="Lesiòn">Lesiòn</option>
                                <option value="Quemadura">Quemadura</option>
                                <option value="Herida Cortante">Herida Cortante</option>
                                <option value="Sustancia Quìmica">Sustancia Quìmica</option>
                                <option value="Otros">Otros</option>
                            </select>
</div>

<div class="col">

                            <!-- Detalle -->
                            <label class="form-label mt-3">Detalle</label>
                            <input type="text" class="form-control" v-model="ticket.detalle" @change="errors.detalle = false" placeholder="Ingrese detalle ...">
                            <span class="text-danger" v-if="errors.detalle">· Ingresa el detalle</span>
</div>

<div class="col">
                            <!-- Tipo de accidente -->
                            <label for="tipoAccidente" class="form-label mt-3">Tipo de accidente</label>
                            <select class="custom-select" v-model="ticket.tipoAccidente">
                                <option :value="null" disabled>Selecciona un tipo</option>
                                <option v-for="(tipo,i) in tipo" :key="i" :value="tipo">{{tipo}}</option>
                            </select>
</div>

</div>


<div class="row mt-3">

    <div class="col">
                             <!-- Responsable -->
                            <label for="responsable" class="form-label mt-3">Responsable</label>
                            <select class="custom-select" v-model="ticket.responsable">
                                <option :value="null" disabled>Selecciona un responsable</option>
                                <option v-for="(responsable,i) in responsable" :key="i" :value="responsable">{{responsable}}</option>
                            </select>
                        </div>

                        <div class="col">

                            <!-- Adjuntar múltiples archivos -->
                            <label for="archivosAdjuntos" class="form-label mt-3">Adjuntar archivos</label>
                            <center><input type="file" class="form-control" multiple ref="fileInput"></center>
                            
                        </div>


</div>


                            <label class="form-label mt-2">Agregar una observacion</label>
                            <!-- Input -->
                            <textarea class="w-100 form-control mb-1" v-model="ticket.observacion" @change="errors.observacion = false" rows="3"></textarea>
                            <span class="text-danger" v-if="errors.observacion">· Es necesario detallar el ticket</span>

                            
                            



                            
                                               
                        </div>
                        <div v-if="errorMessage && !triggers.success" class="alert alert-danger mx-3 mb-2">{{ errorMessage }}</div>
                        <div v-if="loadingEmployee && !triggers.success" class="text-info text-center px-3 mb-2">Cargando datos del empleado...</div>
                        <!-- Buttons footer -->
                        <div class="modal-footer" v-if="!triggers.success">
                            <button
                                type="button"
                                @click.prevent="crearTicket()"
                                class="btn btn-success"
                                :disabled="saving || loadingEmployee"
                            >
                                {{ saving ? 'GUARDANDO...' : 'Crear asignacion' }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </transition>
</template>

<script>
import axios from "axios";
import firebase from "firebase/app";
import "firebase/database";

import 'firebase/storage';  // Importa Firebase Storage

import Select2 from 'vue3-select2-component';

export default {
    components: {Select2},
    name: "ModalLegales",
    props: ['personal'],
    data(){
        return {
            operacionSeleccionada: null,
            listadoPersonalActivo: [],
            novedades: [
                "ART",
                "ENFERMEDAD",
                "RESERVA DE PUESTO",
                "LICENCIA SIN SUELDO",
                "MATERNIDAD",
                "EXEDENCIA"
            ],

            tipo: [
                "-",
                "ACCIDENTE DE TRABAJO",
                "IN-ITINERE",
                "REAGRAVACION REINGRESO",
                "ENFERMEDAD PROFESIONAL"
               
            ],

            responsable: [
                "GONZALO",
                "MARIANO",
                "EDGARDO",
                "SOL",
                "LEGALES"
               
            ],
            triggers: {
                showResolucion: false,
                success: false,
            },
            ticket: {
                dni: null,
                distribucion:null,
                distribucionName:null,
                nombre: null,
                fecha: null,
                hora: null,
                zonal:null,
                responsable:null,
                novedad: null,
                observacion: null,
                resolucion: null,
                status: "ABIERTO",
                sector:"-",
                fechaInicioLicencia: null, // Nuevo campo
                fechaFinLicencia: null, // Nuevo campo
                diagnostico: null, // Nuevo campo
                 detalle: null, // Nuevo campo
                tipoAccidente: null, // Nuevo campo
                archivosAdjuntos: [] // Nuevo campo,

            },
            errors: {
                dni: false,
                novedad: false,
                fechaInicioLicencia: false,
                fechaFinLicencia: false,
                diagnostico: false,
                detalle: false,
                tipoAccidente: false,
                observacion: false,
                archivosAdjuntos: false,
            },
            saving: false,
            loadingEmployee: false,
            loadingPersonal: false,
            errorMessage: null,
            catalogos: null,
            catalogosPromise: null,
            selectionSequence: 0,
            seReasigno: false,
            
        }
    },
    mounted(){
        this.inicializarModal();
    },
    methods: {
        withTimeout(promise, ms = 20000, message = 'La operación demoró demasiado') {
            let timer;
            const timeout = new Promise((_, reject) => {
                timer = setTimeout(() => reject(new Error(message)), ms);
            });
            return Promise.race([promise, timeout]).finally(() => clearTimeout(timer));
        },

        async inicializarModal(){
            this.loadingPersonal = true;
            this.errorMessage = null;

            // Precarga catálogos para que seleccionar un empleado no dispare cuatro esperas nuevas.
            this.cargarCatalogos().catch(error => console.warn('Catálogos parciales:', error));

            try {
                const legalResponse = await axios.get(
                    "https://aplicativos.firebaseio.com/legales.json?print=pretty",
                    { timeout: 15000 }
                );
                const legales = legalResponse.data || {};
                let personalSesion = {};
                try { personalSesion = JSON.parse(sessionStorage.getItem('personal')) || {}; } catch (e) { personalSesion = {}; }
                const personalProp = this.personal || {};
                const personal = Object.keys(personalProp).length ? personalProp : personalSesion;

                this.listadoPersonalActivo = Object.keys(personal).flatMap((key) => {
                    const persona = personal[key];
                    if (!persona || legales[persona.leg_numdoc] != null) return [];
                    return [{
                        id: persona.leg_numero,
                        text: `${persona.leg_apellido || ''} ${persona.leg_nombre || ''}`.trim(),
                        nombre: `${persona.leg_apellido || ''} ${persona.leg_nombre || ''}`.trim(),
                        dni: persona.leg_numdoc
                    }];
                });
            } catch (error) {
                console.warn('No se pudo consultar legales; se habilita el personal disponible.', error);
                let personalSesion = {};
                try { personalSesion = JSON.parse(sessionStorage.getItem('personal')) || {}; } catch (e) { personalSesion = {}; }
                const personalProp = this.personal || {};
                const personal = Object.keys(personalProp).length ? personalProp : personalSesion;
                this.listadoPersonalActivo = Object.keys(personal).flatMap((key) => {
                    const persona = personal[key];
                    if (!persona) return [];
                    return [{
                        id: persona.leg_numero,
                        text: `${persona.leg_apellido || ''} ${persona.leg_nombre || ''}`.trim(),
                        nombre: `${persona.leg_apellido || ''} ${persona.leg_nombre || ''}`.trim(),
                        dni: persona.leg_numdoc
                    }];
                });
                this.errorMessage = 'No se pudo validar temporalmente la lista de legales. Podés continuar con el personal disponible.';
            } finally {
                this.loadingPersonal = false;
            }
        },

        cargarCatalogos(){
            if (this.catalogos) return Promise.resolve(this.catalogos);
            if (this.catalogosPromise) return this.catalogosPromise;

            const safeGet = async (url) => {
                try {
                    return await axios.get(url, { timeout: 15000 });
                } catch (error) {
                    console.warn('Catálogo no disponible:', url, error);
                    return { data: {} };
                }
            };

            this.catalogosPromise = Promise.all([
                safeGet('https://aplicativos.firebaseio.com/distribucion.json?print=pretty'),
                safeGet('https://consumos.foodservice.com.ar/api/empresas'),
                safeGet('https://aplicativos.firebaseio.com/sectores.json?print=pretty'),
                safeGet('https://aplicativos.firebaseio.com/zonal.json?print=pretty')
            ]).then(([distribucion, operaciones, sectores, zonal]) => {
                this.catalogos = {
                    distribucion: distribucion.data || {},
                    operaciones: operaciones.data || {},
                    sectores: sectores.data || {},
                    zonal: zonal.data || {}
                };
                return this.catalogos;
            }).finally(() => {
                this.catalogosPromise = null;
            });

            return this.catalogosPromise;
        },

        async guardarSeleccion({id, dni, nombre}){
            const sequence = ++this.selectionSequence;
            this.loadingEmployee = true;
            this.errorMessage = null;
            this.errors.dni = false;
            this.ticket.dni = dni || null;
            this.ticket.nombre = nombre || '';

            try {
                const { distribucion, operaciones, sectores, zonal } = await this.cargarCatalogos();
                if (sequence !== this.selectionSequence) return;

                let distribucionEncontrada = null;
                Object.keys(distribucion || {}).some((clave) => {
                    const grupo = distribucion[clave] || {};
                    return Object.keys(grupo).some((k) => {
                        const valor = grupo[k];
                        if (valor && String(valor.legajo) === String(id)) {
                            distribucionEncontrada = { operacion: clave, idDistribucion: k };
                            return true;
                        }
                        return false;
                    });
                });

                const operacionId = distribucionEncontrada ? distribucionEncontrada.operacion : '';
                let nombreOperacion = '';

                Object.keys(sectores || {}).some((key) => {
                    const sector = sectores[key];
                    if (sector && String(sector.id_empresa) === String(operacionId)) {
                        nombreOperacion = sector.operacion || '';
                        return true;
                    }
                    return false;
                });

                if (!nombreOperacion) {
                    Object.values(operaciones || {}).some((value) => {
                        if (value && String(value.id) === String(operacionId)) {
                            nombreOperacion = value.name || '';
                            return true;
                        }
                        return false;
                    });
                }

                const zona = zonal && zonal[operacionId] ? zonal[operacionId] : null;
                this.ticket.distribucion = operacionId || '-';
                this.ticket.distribucionName = nombreOperacion || '-';
                this.ticket.zonal = zona && zona.nombre ? zona.nombre : '-';

                if (!distribucionEncontrada) {
                    this.errorMessage = 'El empleado fue seleccionado, pero no se pudo determinar automáticamente su operación. La asignación puede continuar.';
                }
            } catch (error) {
                console.error('Error obteniendo datos del empleado:', error);
                this.ticket.distribucion = this.ticket.distribucion || '-';
                this.ticket.distribucionName = this.ticket.distribucionName || '-';
                this.ticket.zonal = this.ticket.zonal || '-';
                this.errorMessage = 'No se pudieron obtener todos los datos auxiliares del empleado. Podés intentar seleccionarlo nuevamente.';
            } finally {
                if (sequence === this.selectionSequence) this.loadingEmployee = false;
            }
        },

        close(){
            if (this.saving) return;
            this.$emit('cerrar-modal-nuevo', this.seReasigno);
        },

        obtenerFecha(){
            const now = new Date();
            const y = now.getFullYear();
            const m = String(now.getMonth() + 1).padStart(2, '0');
            const d = String(now.getDate()).padStart(2, '0');
            return `${y}-${m}-${d}`;
        },

        obtenerHora(){
            const time = new Date();
            return String(time.getHours()).padStart(2, '0') + ':' + String(time.getMinutes()).padStart(2, '0');
        },

        async crearTicket(){
            if (this.saving || !this.formularioValido()) return;

            this.saving = true;
            this.errorMessage = null;

            try {
                const input = this.$refs.fileInput;
                const files = input ? Array.from(input.files || []) : [];

                const uploadPromises = files.map((file, index) => {
                    const safeName = String(file.name || 'archivo').replace(/[^a-zA-Z0-9._-]/g, '_');
                    const storageRef = firebase.storage().ref(`asignaciones/${Date.now()}_${index}_${safeName}`);
                    return this.withTimeout(
                        storageRef.put(file).then(snapshot => snapshot.ref.getDownloadURL()),
                        120000,
                        'La carga de un archivo demoró demasiado'
                    );
                });

                const urls = await Promise.all(uploadPromises);
                const nuevaAsignacion = firebase.database().ref('/asignaciontemporal').push();
                const firebaseId = nuevaAsignacion.key;

                const payload = {
                    dni: this.ticket.dni,
                    nombre: this.ticket.nombre || '-',
                    fecha: this.obtenerFecha(),
                    hora: this.obtenerHora(),
                    novedad: this.ticket.novedad,
                    observacion: this.ticket.observacion || '',
                    resolucion: this.ticket.resolucion || '',
                    status: this.ticket.status || 'ABIERTO',
                    fechaInicioLicencia: this.ticket.fechaInicioLicencia,
                    fechaFinLicencia: this.ticket.fechaFinLicencia,
                    diagnostico: this.ticket.diagnostico || '-',
                    detalle: this.ticket.detalle || '-',
                    tipoAccidente: this.ticket.tipoAccidente || '-',
                    distribucion: this.ticket.distribucion || '-',
                    distribucionName: this.ticket.distribucionName || '-',
                    zonal: this.ticket.zonal || '-',
                    responsable: this.ticket.responsable || '-',
                    plan: '-',
                    sector: this.ticket.sector || '-',
                    archivosAdjuntos: urls,
                    fireId: firebaseId
                };

                await this.withTimeout(
                    nuevaAsignacion.set(payload),
                    25000,
                    'No se pudo crear la asignación'
                );

                this.triggers.success = true;
                this.seReasigno = true;
                setTimeout(() => this.close(), 700);
            } catch (error) {
                console.error('Error creando asignación:', error);
                this.errorMessage = 'No se pudo crear la asignación. ' + (error.message || 'Verificá la conexión e intentá nuevamente.');
            } finally {
                this.saving = false;
            }
        },

        formularioValido(){
            Object.keys(this.errors).forEach(key => { this.errors[key] = false; });
            let valido = true;

            if (!this.ticket.novedad || this.ticket.novedad === 'null') {
                this.errors.novedad = true;
                valido = false;
            }
            if (!this.ticket.dni) {
                this.errors.dni = true;
                valido = false;
            }
            if (!this.ticket.fechaInicioLicencia) {
                this.errors.fechaInicioLicencia = true;
                valido = false;
            }
            if (!this.ticket.fechaFinLicencia) {
                this.errors.fechaFinLicencia = true;
                valido = false;
            }
            if (this.ticket.fechaInicioLicencia && this.ticket.fechaFinLicencia &&
                this.ticket.fechaFinLicencia < this.ticket.fechaInicioLicencia) {
                this.errors.fechaInicioLicencia = true;
                this.errors.fechaFinLicencia = true;
                this.errorMessage = 'La fecha de fin no puede ser anterior a la fecha de inicio.';
                valido = false;
            }

            return valido;
        }
    }
}
</script>

<style scoped>

input[type="file"] {
    display: block;
}

h3 {
    color: #1ea21e;
}

.input-error {
    border-color: red;
}

.modal-mask {
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
    width: 50%;
    margin: 0px auto;
    padding: 20px;
    background-color: #fff;
    border-radius: 6px;
    box-shadow: 0 2px 8px #00000016;
    transition: all .3s ease;
    font-size: 16px;

    max-height: 90vh;
    overflow-y: auto;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-body select {
    margin-bottom: 1rem;
}

input, select {
    font-size: 16px;
}

.modal-default-button {
  float: right;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>